/**
 * Created by PuTi(编程即菩提) 2/26/18.
 */
var nb = require('../../core/js/nb');
var cookie = require('../lib/cookie');
var keyMap = {
    aid: false,//application ID
    cookieId: true,//client ID<cookie ID>
    userId: true,//user ID
    action: true,//action
    desc:true,
    type:true,
    cts: true,//client time stamp
    sts: false,//server time stamp
    skuId: true,
    startTime: true,
    endTime: true,
    page: true,
    downPage:true,
    apiType:true
};
var Pool = nb.define({
    method: {
        trace: function (inParam) {
            var $img = $('<img>');
            $img.attr('src', inParam);
        }
    }
});

var pool = new Pool();

function getReferrer() {
    var referrer = '';
    try {
        referrer = window.top.document.referrer;
    } catch (e) {
        if (window.parent) {
            try {
                referrer = window.parent.document.referrer;
            } catch (e2) {
                referrer = '';
            }
        }
    }
    if (referrer === '') {
        referrer = document.referrer;
    }
    return referrer;
}

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}

var Trace = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            this.setOpts({
                url: './t.jpg?',
                clientIdKey: '_t_client_id',
                userIdKey: '_t_user_id'
            });
            this.onChange('userId', function (inEvent, inUserId) {
                cookie.set(this.get('userIdKey'), inUserId);
            }, this);
        },
        getCookieId: function () {
            var clientId = this.get('clientId');
            var clientIdKey = this.get('clientIdKey');
            if (!clientId) {
                clientId = cookie.get(clientIdKey);
            }
            if (!clientId) {
                clientId = guid();
                this.set('clientId', clientId);
                cookie.set(clientIdKey, clientId);
            }
            return clientId;
        },
        getUserId: function () {
            var userId = this._userId;
            var userIdKey = this.get('userIdKey');
            if (!userId) {
                userId = this._userId = cookie.get(userIdKey);
            }
            return userId;
        },
        setAppId: function (inAppId) {
            this.set('appId', inAppId);
        },
        setUserId: function (inUserId) {
            this.set('userId', inUserId);
        },
        log: function (inJSON) {
            var paramList = [];
            var appId = this.get('appId');
            var userId = this.getUserId();
            $.each(keyMap, function (inKey, inValue) {
                var value = inJSON[inKey];
                if (value) {
                    paramList.push(inKey + '=' + value);
                }
            });
            if (userId) {
                paramList.unshift('userId=' + userId);
            }
            paramList.unshift('downPage=' + getReferrer());
            paramList.unshift('page=' + location.href);
            // paramList.unshift('aid=' + this.get('appId'));
            paramList.unshift('cookieId=' + this.getCookieId());
            // paramList.push('cts=' + new Date().getTime());
            pool.trace(this.get('url') + paramList.join('&'));
        },
        clear: function () {
            this.set('userId', null);
            this.set('clientId', null);
            cookie.remove(this.get('userIdKey'));
            cookie.remove(this.get('clientIdKey'));
        }
    }
});

trace = new Trace();

module.exports = trace;


//////////////////
// WEBPACK FOOTER
// ../src/nb/trace/js/trace.js
// module id = 17
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32